var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7290853,2.96879069 C21.0628023,2.8019322 21.1698405,2.91190592 20.9689941,3.21317546 L20.3643392,4.12015788 C20.1631202,4.42198635 19.7547607,4.83015951 19.4534912,5.03100586 L18.5465088,5.63566081 C18.2446803,5.83687979 17.7890625,6.2109375 17.5297496,6.47025045 L17.8035838,6.19641622 C17.5438716,6.45612837 17.5416667,6.875 17.7996686,7.13300196 L18.2003314,7.5336647 C18.4578812,7.79121458 18.4583333,8.20833333 18.2003314,8.4663353 L17.7996686,8.86699804 C17.5421188,9.12454791 17.0635134,9.19842339 16.7290853,9.03120931 L16.604248,8.96879069 C16.2705311,8.8019322 15.8650901,8.93648656 15.697876,9.27091471 L15.6354574,9.39575195 C15.4685989,9.72946893 15.0552419,10.0926971 14.7005208,10.2109375 L13.9661458,10.4557292 C13.6166531,10.5722267 13.0374235,10.6666667 12.6666667,10.6666667 L12.6666667,10.6666667 C12.2984768,10.6666667 11.8650901,10.9364866 11.697876,11.2709147 L11.6354574,11.395752 C11.4685989,11.7294689 11.067894,11.8672803 10.7415136,11.7040901 L9.25848643,10.9625765 C8.9316334,10.79915 8.45833333,10.4583333 8.20033137,10.2003314 L7.79966863,9.79966863 C7.54211876,9.54211876 7.33333333,9.03742345 7.33333333,8.66666667 L7.33333333,8.66666667 C7.33333333,8.29847683 7.63545736,8 7.99251302,8 L7.34082031,8 C7.7048752,8 8.20833333,7.79166667 8.4663353,7.5336647 L8.86699804,7.13300196 C9.12454791,6.87545209 9.62924321,6.66666667 10,6.66666667 L10,6.66666667 C10.3681898,6.66666667 10.7593638,6.38857524 10.8776042,6.03385417 L11.1223958,5.29947917 C11.2388934,4.94998647 11.6175315,4.72350629 11.9918927,4.79837855 L14.0081073,5.20162145 C14.3718196,5.27436392 14.9520467,5.26198832 15.3121923,5.17195193 L16.6878077,4.82804807 C17.0443217,4.73891958 17.6031532,4.53175672 17.9375814,4.36454264 L18.0624186,4.30212402 C18.3961356,4.13526553 18.9364866,3.86509005 19.2709147,3.69787598 L19.395752,3.63545736 C19.7294689,3.46859887 20.2698199,3.19842339 20.604248,3.03120931 L20.7290853,2.96879069 Z",
    id: "Line",
    fill: "#E7832C",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-81",
    fill: "#445128",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 15.3333333,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,14.6666667 C16,14.6666667 18,14 18.6666667,12.6666667",
    id: "Line",
    stroke: "#445128",
    strokeWidth: 1.33333333,
    opacity: 0.75,
    strokeLinecap: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,14.6666667 C9.33333333,14.6666667 11.3333333,14 12,12.6666667",
    id: "Line",
    stroke: "#445128",
    strokeWidth: 1.33333333,
    opacity: 0.75,
    strokeLinecap: "round",
    mask: "url(#mask-2)",
    transform: "translate(10.666667, 13.666667) scale(-1, 1) translate(-10.666667, -13.666667) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/CY.f29593cd5703b6b890f62dc82bd44b45.svg";
export { ForwardRef as ReactComponent };